import { defineMessages } from 'react-intl';

import { generateDropdownOptions } from '@ratehub/base-ui';

import { GENDERS } from './CurrentDocument';


// Required as some insurance wizards do not support other gender types yet
const subsetOfValues = [
    GENDERS.MALE,
    GENDERS.FEMALE,
];

const GenderMessages = defineMessages({
    [GENDERS.MALE]: {
        id: 'Insurance.gender.male',
        defaultMessage: 'Male',
    },
    [GENDERS.FEMALE]: {
        id: 'Insurance.gender.female',
        defaultMessage: 'Female',
    },
});

// For insurance wizards supporting Gender X
// Using defineMessages (plural) as we require a key on the object for generateDropdownOptions
const ExtendedGenderMessages = defineMessages({
    [GENDERS.OTHERS]: {
        id: 'Insurance.gender.gender-x',
        defaultMessage: 'Gender X',
    },
});

const GenderOptions = generateDropdownOptions(
    subsetOfValues,
    GenderMessages,
);

const ExtendedGenderOptions = generateDropdownOptions(
    GENDERS,
    {
        ...GenderMessages,
        ...ExtendedGenderMessages,
    },
);

export { ExtendedGenderOptions };

export default GenderOptions;
